import { vdkEmHappinessPortalApi } from './vdk-em-happiness-portal-api';
const createExternalRelation = (payload) => {
    return vdkEmHappinessPortalApi.post('/externalrelations/create', payload);
};
const updateExternalRelation = (payload) => {
    return vdkEmHappinessPortalApi.put('/externalrelations/update', payload);
};
const getAllExternalRelations = (payload) => {
    return vdkEmHappinessPortalApi.post('/externalrelations/get-all', payload);
};
const getExternalRelationById = (id) => {
    return vdkEmHappinessPortalApi.get(`/externalrelations/${id}`);
};
const deleteExternalRelation = (id) => {
    return vdkEmHappinessPortalApi.delete(`/externalrelations/${id}`);
};
const getAllExternalRelationsWithoutPagination = (eventId) => {
    return vdkEmHappinessPortalApi.post('/external-relations/get-all-without-pagination', {
        eventId: eventId
    });
};
const getAllExternalRelationRecentEvents = (payload) => {
    return vdkEmHappinessPortalApi.post('/externalrelations/external-relations-recent-events/get-all', payload);
};
const ExternalRelationsApi = {
    createExternalRelation,
    updateExternalRelation,
    getAllExternalRelations,
    getExternalRelationById,
    deleteExternalRelation,
    getAllExternalRelationsWithoutPagination,
    getAllExternalRelationRecentEvents
};
export default ExternalRelationsApi;
